// @ts-nocheck
import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { css } from "styled-components";

Object.assign(addToListModalStyles, {
    userRemoveLink: {
        css: css`
            ${linkStyles("secondary", null, false, true)};
            margin-left: auto;
        `,
    },
});
